import { AiUsageByUserItem, AiUsageByUserRow } from './types';

export default function toAiUsageRows(
  collection: AiUsageByUserItem[] = [],
): AiUsageByUserRow[] {
  return collection.map((item) => ({ ...item, id: item.user.id }));
}
